import React, { Component } from 'react';
// Composants
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
// Style
import './DropdownIdName.css';

/**
 * Ce dropdown peut etre utilisé pour les bu ainsi que les shops
 */
class DropdownIdName extends Component {

    /**
     * Action au changement de valeur dans le dropdown
     * @param {*} event
     * @param {*} index
     * @param {*} value
     */
    onChange = (event, index, value) => {
        // Si on essaye de resélectioner un item on ne fait rien
        if (this.props.selectedItem && this.props.selectedItem.name === value) {
            return;
        }

        const selectedItem  = this.props.itemList.find(bu => bu.name === value);

        this.props.selectItem(selectedItem);
    };

    render() {
        return (
            <div className="dropdownIdNameContainer">
                <span className="dropDownIdNameLabel">{this.props.label}</span>
                <DropDownMenu className="dropdownIdName"
                              value={this.props.selectedItem ? this.props.selectedItem.name : ''}
                              onChange={this.onChange}
                              disabled={this.props.disabled}
                              {...this.props.configs}>
                    {this.props.itemList.map(item =>
                        <MenuItem key={item.id} id={item.id} value={item.name} primaryText={item.name}/>
                    )}
                </DropDownMenu>
            </div>
        );
    }

}

DropdownIdName.defaultProps = {
    itemList: [],
    configs: {}
};

export default DropdownIdName;



// WEBPACK FOOTER //
// ./src/components/dropdownIdName/DropdownIdName.js